import { CONFIG } from '../data/config';

export default function Footer() {
  return (
    <footer className="foot">
      <div className="container">
        <div className="row-top" />
        <div className="foot-grid">
          <div>
            <h6>Group</h6>
            <ul>
              <li><a href="#business">Business</a></li>
              <li><a href="#federation">Federation Model</a></li>
              <li><a href="#growth">Growth</a></li>
              <li><a href="#leadership">Leadership</a></li>
            </ul>
          </div>
          <div>
            <h6>Contact</h6>
            <ul>
              <li><a href="mailto:me-pr@mystar.co.jp">me-pr@mystar.co.jp</a></li>
            </ul>
          </div>
          <div>
            <h6>Japanese site</h6>
            <ul>
              <li>
                <a href="https://www.mystargroup.jp/" target="_blank" rel="noreferrer">
                  mystargroup.jp →
                </a>
              </li>
              <li>
                <a
                  href="https://www.mystargroup.jp/group/officer/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Officer profiles (JP)
                </a>
              </li>
              <li>
                <a
                  href="https://www.mystargroup.jp/news"
                  target="_blank"
                  rel="noreferrer"
                >
                  News (JP)
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="bot">
          <span>© 2026 Mystar Engineering Corp. All rights reserved.</span>
          <span>
            HQ {CONFIG.hq} · Founded {CONFIG.founded}
          </span>
        </div>
      </div>
    </footer>
  );
}
